<template>
  <validation-observer v-if="visible" ref="evalutatorAssignmentFromRef">
    <div class="bg-secondary-1 mt-4 p-4 d-flex justify-content-between">
      <div>
        <section-title
          bg-icon="bg-white"
          class="section-title"
          :has-line="false"
          icon="fas fa-users text-orange"
          :reverse="true"
          title="Asignar Propuesta a Evaluadores (Seleccione Evaluador)"
        />

        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="evaluatorToAssaing"
            custom-error-msg="Favor seleccione un evaluador."
            :error="errors[0]"
            fieldkey="userId"
            fieldname="fullName"
            :options="evaluatorsToAssaing"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <action-button
          class="py-2 px-4 mr-md-2"
          i="fa fa-times-circle"
          variant="outline-danger"
          @click="onCancelHandler"
        >
          Cancelar
        </action-button>
        <action-button
          class="py-2 px-4"
          variant="success"
          @click="onAddHandler"
        >
          Asignar
        </action-button>
      </div>
    </div>
  </validation-observer>
</template>
<script>
import Vue from 'vue';
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import alertMixin from 'utils/mixins/alert.mixin';
import {
  getSelectedEvaluators as _getSelectedEvaluators,
  addEvaluatorUserProposal as _addEvaluatorUserProposal,
} from '@/modules/serviceProposalHistory/api.js';

export default {
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
    bus: {
      type: Vue,
      default: () => new Vue(),
    },
    academicYearId: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    evaluatorToAssaing: null,
    evaluatorsToAssaing: [],
  }),
  mounted() {
    this.initFilter();
  },
  methods: {
    onCancelHandler() {
      this.$emit('cancel');
    },
    async initFilter() {
      await _getSelectedEvaluators({
        academicYearId: this.academicYearId,
        pageSize: 200,
      }).then(({ data }) => {
        this.evaluatorsToAssaing = [...data.data];
      });
    },
    async onAddHandler() {
      const isValid = await this.$refs.evalutatorAssignmentFromRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      // Agregar
      let parameters = {
        ProposalRequestId: parseInt(this.$route.params.proposalRequestId),
        UserId: this.evaluatorToAssaing.userId,
      };

      await _addEvaluatorUserProposal(parameters)
        .then(async () => {
          await this.initFilter();

          this.ShowToast(
            'Alerta',
            'El evaluador ha sido asignado exitosamente.',
            'success'
          );

          this.bus.$emit('assignedEvaluator');
          this.$emit('on-add');
          this.onCancelHandler();
          this.evaluatorToAssaing = null;
        })
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
  },
};
</script>
